// 客户端类型常量
export const CLIENT_TYPES = [
  { value: 'WEB', label: 'Web', color: 'blue', icon: 'global' },
  { value: 'IOS', label: 'iOS', color: 'cyan', icon: 'apple' },
  { value: 'ANDROID', label: 'Android', color: 'green', icon: 'android' },
  { value: 'MINI_PROGRAM', label: '微信小程序', color: 'lime', icon: 'wechat' },
  { value: 'GATEWAY', label: '网关', color: 'geekblue', icon: 'gateway' },
  { value: 'SENSOR', label: '传感器', color: 'gold', icon: 'api'},
  { value: 'EDGE_NODE', label: '边缘节点', color: 'purple', icon: 'block'},
  { value: 'CONTROLLER', label: '控制器', color: 'magenta', icon: 'control' },
]

// 客户端分类
export const CLIENT_CATEGORIES = [
  { value: 'APPLICATION', label: '应用型客户端' },
  { value: 'DEVICE', label: '设备型客户端' },
]

// 设备系列（用于型号管理）
export const DEVICE_SERIES = [
  { value: 'photoFrame', label: '相框' },
  { value: 'eink', label: '墨水屏' },
  { value: 'smartGateway', label: '智能网关' },
  { value: 'sensor', label: '传感器' },
  { value: 'edgeNode', label: '边缘节点' },
]

// 根据分类获取可用类型
export function getTypesByCategory(category) {
  if (!category) return []
  if (category === 'APPLICATION') {
    return CLIENT_TYPES.filter((t) => ['WEB', 'IOS', 'ANDROID', 'MINI_PROGRAM'].includes(t.value))
  } else if (category === 'DEVICE') {
    return CLIENT_TYPES.filter((t) => ['GATEWAY', 'SENSOR', 'EDGE_NODE', 'CONTROLLER'].includes(t.value))
  }
  return CLIENT_TYPES
}
